module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-28-415e22176806972a0af0a1464166ac06.svg";